import { combineReducers } from 'redux';

import toogleReducer from './toggle-hidden/toggle-hidden.reducer';
import pictureReducer from './picture/picture.reducer';
import musicReducer from './music/music.reducer'

const rootReducer = combineReducers({
    toggle: toogleReducer,
    picture: pictureReducer,
	music: musicReducer
});

export default rootReducer;
